import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { supportedLanguages, setExplicitLanguage } from '@/i18n';
import styles from './LanguageSwitcher.module.scss';

export const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    document.documentElement.lang = i18n.resolvedLanguage ?? 'en';
  }, [i18n.resolvedLanguage]);

  return (
    <select
      aria-label="Language"
      className={styles.select}
      value={i18n.resolvedLanguage}
      onChange={(e) => setExplicitLanguage(e.target.value)}
    >
      {supportedLanguages.map(({ code, label }) => (
        <option key={code} value={code}>
          {label}
        </option>
      ))}
    </select>
  );
};
